<main id="messages-maintenance" class="maintenance-form">
    <h2>Edit Messages</h2>
    <div>
        <input type="radio" name="message-type" id="maintain-greeting" value="greetings"  on:click={() => typeClick('g')}   checked>
        Greetings
    </div>
    <div>
        <input type="radio" name="message-type" id="maintain-valediction" value="valediction" on:click={() => typeClick('v')}>
        Valedictions
    </div>

    <MessageForm {messages} {default_message} />

    <div class="buttons">
        <button class="select-button" on:click={saveData}>Save</button>
        <button id="new-message" class="select-button" on:click={newMessage}>New</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
</main>

<style>
    #messages-maintenance {
        display: none;
        width: 60vw;
    }
</style>

<script>
    import MessageForm from './MessageForm.svelte';

    import { user,  state} from './data-store.js'
    import { writeToUser } from './user.js';
    import { elementDisplay } from './utilities'
    import { buildMessage } from './common'

    let greeting_valediction = 'g';
    // $: length = $user.greetings.length + $user.valedictions.length
    $: message_source = $user.greeting_list
    $: messages = message_source
    $: default_message = $user.default_greeting

    function  typeClick(message_type) {
        greeting_valediction = message_type;
        if (greeting_valediction == 'g') {
            messages = $user.greeting_list
            default_message = $user.default_greeting;
        } else {
            messages = $user.valediction_list
            default_message = $user.default_valediction;
        }
    }

    function newMessage() {
        messages.push(['']);
        messages = messages
    }

    function close() {
        elementDisplay('messages-maintenance', 'none')
    }

    function saveData() {
        let messages = []
        let message_fields = document.getElementsByClassName("message-input");
        for (let index = 0; index < message_fields.length; index++) {
            let delete_checkbox = document.getElementById(`delete-message-${index}`);
            if (delete_checkbox.checked) {
                delete_checkbox.checked = false;
                continue
            }

            let field = message_fields[index]
            let message = field.value
            if (!message) {
                continue
            }

            let default_rb = document.getElementById(`default-message-${index}`);
            if (default_rb.checked) {
                default_message = message;
            }

            if (greeting_valediction == 'g' &&
                    $user.greetings[index] == $user.selected_greeting) {
                $user.selected_greeting = message
            }
            if (greeting_valediction == 'v' &&
                    $user.valedictions[index] == $user.selected_valediction) {
                $user.selected_valediction = message
            }
            messages.push(message);
        }
        if (greeting_valediction == 'g') {
            $user.default_greeting = default_message;
            $user.greeting_list = messages;
        } else {
            $user.default_valediction = default_message;
            $user.valediction_list = messages;
        }
        message_source = messages
        $state.message = buildMessage()
        writeToUser();
        close();
    }
</script>